import { observable, action } from 'mobx'
import store from '../store'
class Store {
  map
  marker
  point
  address
  @observable visible = false
  @action
  showMap() {
    this.visible = true
  }
  @action
  cancel() {
    this.visible = false
  }
  @action
  submit(myStore) {
    this.visible = false
    if (this.address) {
      myStore.address = this.address
      myStore.longitude = this.point[0]
      myStore.latitude = this.point[1]
      myStore.map.setCenter(this.point)
      myStore.marker.setMap(myStore.map)
      myStore.marker.setPosition(this.point)
    }
  }

  @action
  getMap(map, marker) {
    this.map = map
    this.marker = marker
    let lon = store.longitude
    let lat = store.latitude
    if (!(lon && lat)) {
      map.setCenter()
    } else {
      map.setCenter([lon, lat])
      marker.setMap(map)
      marker.setPosition([lon, lat])
    }
  }
}

export default new Store()
